import template from './printed-bills.html';
import controller from './printed-bills.controller';
import './printed-bills.scss';

let PrintedBillsComponent = {
  bindings: {},
  template,
  controller
};

export default PrintedBillsComponent;



// WEBPACK FOOTER //
// ./src/app/pages/printed-bills/printed-bills.component.js